export default {"src":"/_next/static/media/mail.4a9e1326.svg","height":16,"width":20,"blurWidth":0,"blurHeight":0};